import { Component, Input, OnInit } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-reconciliation-confirmation-modal",
  templateUrl: "./reconciliation-confirmation-modal.page.html",
  styleUrls: ["./reconciliation-confirmation-modal.page.scss"],
})
export class ReconciliationConfirmationModalPage implements OnInit {

  @Input() receiptsAmount: number;

  clerkId = "";
  constructor(private translate: TranslateService, private modalController: ModalController) { }

  ngOnInit() {
  }

  doCancel() {
    this.modalController.dismiss({msg: "Cancel"});
  }

  doOk() {
    this.modalController.dismiss({msg: "Ok", clerkId: this.clerkId});
  }

}
